export default {
	events: {
		'ddc.wstagging.first': [
			{
				payload: {}
			}
		],
		asc_pageview: [
			{
				payload: {
					brandId: 'AUDIUS',
					dealerCode: '[[dealerCode.aoa]]',
					partnerCode: 'coxddcsites'
				}
			}
		],
		'*': [
			{
				payload: {}
			}
		]
	}
};
